import React, { useState } from "react";
import { Container, Card, Button, Form } from "react-bootstrap";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import Header from './Header';
import Footer from './Footer';

const JpgToPdfConverter = () => {
  const [images, setImages] = useState([]);

  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);
    setImages(files.map((file) => URL.createObjectURL(file)));
  };

  const convertToPdf = async () => {
    const doc = new jsPDF();
    for (let i = 0; i < images.length; i++) {
      const img = new Image();
      img.src = images[i];
      await new Promise((resolve) => {
        img.onload = () => {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");
          canvas.width = img.width;
          canvas.height = img.height;
          ctx.drawImage(img, 0, 0);
          const imgData = canvas.toDataURL("image/jpeg");
          if (i > 0) doc.addPage();
          doc.addImage(imgData, "JPEG", 10, 10, 180, 160);
          resolve();
        };
      });
    }
    doc.save("converted.pdf");
  };

  return (
    <>
    <Header />
    <div className="full-div" id="blog">
    <Container className="d-flex justify-content-center align-items-center" style={{ marginTop: "5%", marginBottom: "10%" }}>
      <div className="shadow p-4 w-100 toolcontainer" >
        <h2 className="text-center mb-4">JPG to PDF Converter | Fast, Free & High-Quality</h2>
        <p className="text-dark">
          Our JPG to PDF Converter is a free and easy-to-use online tool that lets you quickly convert JPG images into high-quality PDF files. Whether you need to merge multiple JPGs into a single PDF or convert individual images, our tool ensures a seamless experience. No software installation is required—just upload your JPG file, click convert, and download your PDF instantly. It maintains image quality, supports batch conversion, and works on all devices. Secure, fast, and reliable, our converter is perfect for students, professionals, and anyone needing a hassle-free JPG to PDF conversion. Try it now for free! 🚀
        </p>
        <Form.Group controlId="fileInput" className="mb-3">
          <Form.Control type="file" multiple accept="image/jpg" onChange={handleFileChange} />
        </Form.Group>
        <div id="preview" className="p-3 text-center">
          {images.map((src, index) => (
            <img key={index} src={src} alt={`preview-${index}`} className="img-fluid m-2" style={{ maxWidth: "100px" }} />
          ))}
        </div>
        <Button onClick={convertToPdf} className="btn-primary mt-3">Convert to PDF</Button>
      </div>
    </Container>
    </div>
    <Footer />
    </>
  );
};

export default JpgToPdfConverter;
